import {NetworkSetup as NetworkSetupType} from '@chekin/core';
import {InstallationSteps} from './components/InstallationSteps';
import {Value} from './components/Value';
import {useTranslation} from 'react-i18next';

type Props = {
  details: NetworkSetupType;
};
export const NetworkSetup = ({details}: Props) => {
  const {t} = useTranslation();
  return (
    <div className="flex flex-col gap-6">
      <Value label={t('esim.my.apn_value')} value={details.apn_value} />
      <InstallationSteps steps={details.steps} />
    </div>
  );
};
